/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface SMSearchListItem
 */
export interface SMSearchListItem {
    /**
     * 
     * @type {string}
     * @memberof SMSearchListItem
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SMSearchListItem
     */
    disabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SMSearchListItem
     */
    deleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SMSearchListItem
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof SMSearchListItem
     */
    supplier?: GuidIdAndLabel;
    /**
     * 
     * @type {string}
     * @memberof SMSearchListItem
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SMSearchListItem
     */
    details?: string | null;
    /**
     * 
     * @type {Array<GuidIdCodeAndLabel>}
     * @memberof SMSearchListItem
     */
    readonly preferredCarriers?: Array<GuidIdCodeAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdCodeAndLabel>}
     * @memberof SMSearchListItem
     */
    readonly prohibitedCarriers?: Array<GuidIdCodeAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdCodeAndLabel>}
     * @memberof SMSearchListItem
     */
    readonly permittedCarriers?: Array<GuidIdCodeAndLabel> | null;
    /**
     * 
     * @type {number}
     * @memberof SMSearchListItem
     */
    maxPriceSolutions?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SMSearchListItem
     */
    maxPricePoints?: number | null;
}

export function SMSearchListItemFromJSON(json: any): SMSearchListItem {
    return SMSearchListItemFromJSONTyped(json, false);
}

export function SMSearchListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SMSearchListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'supplier': !exists(json, 'supplier') ? undefined : GuidIdAndLabelFromJSON(json['supplier']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'details': !exists(json, 'details') ? undefined : json['details'],
        'preferredCarriers': !exists(json, 'preferredCarriers') ? undefined : (json['preferredCarriers'] === null ? null : (json['preferredCarriers'] as Array<any>).map(GuidIdCodeAndLabelFromJSON)),
        'prohibitedCarriers': !exists(json, 'prohibitedCarriers') ? undefined : (json['prohibitedCarriers'] === null ? null : (json['prohibitedCarriers'] as Array<any>).map(GuidIdCodeAndLabelFromJSON)),
        'permittedCarriers': !exists(json, 'permittedCarriers') ? undefined : (json['permittedCarriers'] === null ? null : (json['permittedCarriers'] as Array<any>).map(GuidIdCodeAndLabelFromJSON)),
        'maxPriceSolutions': !exists(json, 'maxPriceSolutions') ? undefined : json['maxPriceSolutions'],
        'maxPricePoints': !exists(json, 'maxPricePoints') ? undefined : json['maxPricePoints'],
    };
}

export function SMSearchListItemToJSON(value?: SMSearchListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
        'deleted': value.deleted,
        'allowEdit': value.allowEdit,
        'supplier': GuidIdAndLabelToJSON(value.supplier),
        'description': value.description,
        'details': value.details,
        'maxPriceSolutions': value.maxPriceSolutions,
        'maxPricePoints': value.maxPricePoints,
    };
}


